import { render, staticRenderFns } from "./MemberFriendsView.vue?vue&type=template&id=5041041f&scoped=true"
import script from "./MemberFriendsView.vue?vue&type=script&lang=js"
export * from "./MemberFriendsView.vue?vue&type=script&lang=js"
import style0 from "./MemberFriendsView.vue?vue&type=style&index=0&id=5041041f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5041041f",
  null
  
)

export default component.exports